import * as v from "valibot";

// request schemas
export const RequestSchema = v.object({
  AddonIds: v.nullish(v.array(v.string())),
  AddonNames: v.nullish(v.array(v.string())),
  ClusterId: v.string(),
  // ClusterName: v.string(),
});
export type Request = v.InferOutput<typeof RequestSchema>;

// response schema
export const AddonSchema = v.object({
  AddonId: v.string(),
  AddonVersion: v.string(),
  Args: v.nullish(v.record(v.string(), v.string())),
  ClusterId: v.string(),
  CreatedTime: v.string(),
  InstanceId: v.string(),
  Message: v.string(),
  Name: v.string(),
  Namespace: v.nullish(v.string()),
  Phase: v.string(),
  Reason: v.string(),
  ReleaseName: v.nullish(v.string()),
  ToDelete: v.boolean(),
  Type: v.string(),
});
export type Addon = v.InferOutput<typeof AddonSchema>;

export const DataSchema = v.object({
  Addons: v.array(AddonSchema),
});
export type Data = v.InferOutput<typeof DataSchema>;

export const ResponseSchema = v.object({
  Data: DataSchema,
  RequestId: v.string(),
});
export type Response = v.InferOutput<typeof ResponseSchema>;
